import { queryOptions, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { OAuthURL, User, api } from "@/lib/api";
import { unwrapAxiosData } from "@/lib/api/query-utils";

const keys = {
  loginUrl: () => ["login_url"] as const,
  logoutUrl: () => ["logout_url"] as const,
  userInfo: () => ["userInfo"] as const,
};

export const cognitoSignInUrlQuery = (callbackUrl: string, state: string) =>
  queryOptions({
    queryKey: keys.loginUrl(),
    queryFn: (): Promise<AxiosResponse<OAuthURL>> =>
      api.authorization.getCognitoSigninUrl(callbackUrl, state),
    select: (response) => response.data.url,
    staleTime: 0,
  });

export const useCognitoSignOutUrlQuery = (callbackUrl: string) =>
  useQuery({
    queryKey: keys.logoutUrl(),
    queryFn: (): Promise<AxiosResponse<OAuthURL>> =>
      api.authorization.getCognitoSignoutUrl(callbackUrl),
    select: (response) => response.data.url,
  });

export const userInfoQuery = () =>
  queryOptions({
    queryKey: keys.userInfo(),
    queryFn: (): Promise<User> => unwrapAxiosData(api.users.getCurrentUserInfo()),
  });

export const useUserInfoQuery = () => useQuery(userInfoQuery());
